import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';

export type ButtonVariant = 'primary' | 'secondary' | 'whatsapp';

@Component({
  selector: 'app-button',
  imports: [CommonModule],
  templateUrl: './app-button.html',
  styleUrl: './app-button.scss',
})
export class AppButton {
  variant = input<ButtonVariant>('primary');
  loading = input<boolean>(false);
  disabled = input<boolean>(false);

  pressed = output<MouseEvent>();

  readonly variantClasses = computed(() => {
    switch (this.variant()) {
      case 'primary':
        return 'bg-[#141B35] border-[#141B35] w-full text-white border border-color-[#141B35]';
      case 'secondary':
        return 'bg-white text-[#e11319] hover:bg-[#e11319] hover:text-white border-[#e11319] w-full border border-color-[#e11319]';
      case 'whatsapp':
        return 'bg-[#25d366] border-[#25d366] hover:bg-[#24c15f] w-full';
      default:
        return '';
    }
  });

  handleClick(event: MouseEvent) {
    if (this.loading() || this.disabled()) {
      event.preventDefault();
      return;
    }

    this.pressed.emit(event);
  }
}
